import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import { useResource } from 'app/common/api';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { appRoute } from 'app/terminals/router/routes';
import { Loading } from 'app/ui';

import { TTerminalProfile } from '../../../profiles/core/profiles';
import { TTerminal, TTerminalType } from '../../core/terminal';
import { addTerminalRequest } from '../../requests/add-terminal.request';
import { TerminalForm } from '../terminal-form/terminal-form';

type NewTerminal = Omit<TTerminal, 'id' | 'profile' | 'type'> & {
  profile?: Pick<TTerminalProfile, 'id'>;
  type: Pick<TTerminalType, 'id'>;
};

export const AddTerminal = observer(() => {
  const navigate = useNavigate();
  const notify = usePageNotify();

  const addTerminalResource = useResource<NewTerminal, TTerminal>({
    request: addTerminalRequest,
    errorNotify: notify,
    onDone: (result) => {
      const newTerminalId = result.id;
      const newTerminalPath = appRoute.TERMINAL.buildPath({
        id: newTerminalId,
      });

      navigate(newTerminalPath);
    },
  });

  const handleSubmit = (fields: NewTerminal) => {
    addTerminalResource.send(fields);
  };

  return (
    <Loading active={addTerminalResource.isLoading}>
      <TerminalForm onSubmit={handleSubmit} dsnReadOnluly={false} />
    </Loading>
  );
});
